type UploadResult = {
  url?: string | null
}

export const uploadBase64 = async (
  base64String: string
): Promise<UploadResult> => {
  if (!base64String) {
    return {url: null}
  }

  const cloudName = 'discountcodes'
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`

  const formData = new FormData()
  formData.append('file', base64String) // base64 string includes `data:image/...;base64,...`
  formData.append('upload_preset', 'mtguzd9s')

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    })

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`)
    }

    const data = await response.json()

    if (data?.url) {
      return {url: data.url}
    } else {
      throw new Error('No URL returned from Cloudinary.')
    }
  } catch (error) {
    return Promise.reject({
      url: null,
      message:
        error instanceof Error ? error.message : 'Unknown error occurred',
    })
  }
}
